import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { Data, AccordionIcon } from '../../data/AccordionData';
import { colors } from '../../theme';

const AccordionSection = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  background: ${colors.transparent};
`;

const ULContainer = styled.ul`
  padding: 0px;
  list-style: none;

  .nav-link {
    color: ${colors.primary.black90};
    -webkit-transition: all 0.3s ease-out;
    -moz-transition: all 0.3s ease-out;
    -ms-transition: all 0.3s ease-out;
    -o-transition: all 0.3s ease-out;
    transition: all 0.3s ease-out;
    display: block;
    vertical-align: middle;
    font-size: 15px;
    border-radius: 0.1875rem;
    position: relative;
    padding: 7px 0;
    outline-width: 0;
    cursor: pointer;
    text-decoration: none;
  }

  span {
    margin-right: 1.2rem;
  }

  .accordion-collapse-icon {
    position: absolute;
    right: 0;
    margin-top: 4px;
    font-size: 15px;
  }
  span.sidebar-menu-icon {
    vertical-align: -6px;
    margin-right: 10px !important;
  }

  .nav-item:hover, .nav-item.active {
    background-color: ${colors.sidebarbg};
  }
  
`;

const ListItem = styled.li`
  padding: 8px 12px;
  list-style: none;
  line-height: 0px;
`;

const SubmenuULContainer = styled.ul`
  color: ${colors.primary.black90};
  display: flex;
  padding: 0;
  flex-direction: column;
  p {
    font-size: 1rem;
  }
  .nav-item {
    padding-left: 34px;
  }
`;


export const Accordion = () => {
  const [clicked, setClicked] = useState(false);
  const location = useLocation();

  const toggle = (index) => {
    if (clicked === index) {
      return setClicked(null);
    }
    setClicked(index);
  };

  return (
    <AccordionSection>
      <ULContainer className="sidebar-menu">
        {Data.map((item, index) => (
          <React.Fragment key={`menu${index}`}>
            {/* if menu has submenu */}
            {item.submenu ? (
              <ListItem className="nav-item" onClick={() => toggle(index)} >
                <Link to={'#'} className={'nav-link'}>
                  <span className="sidebar-menu-icon">
                    <item.icon />
                  </span>
                  {item.menu}
                  <>
                    {clicked === index ? (
                      <AccordionIcon.minusIcon className="accordion-collapse-icon" />
                    ) : (
                      <AccordionIcon.plusIcon className="accordion-collapse-icon" />
                    )}
                  </>
                </Link>
              </ListItem>
            ) : (
              // if menu hasn't submenu
              <ListItem className={'nav-item' + (item?.url.includes(location?.pathname) ? ' active' : '')} key={item.id}>
                <Link
                  className={'nav-link'}
                  to={item?.url}
                >
                  <span className="sidebar-menu-icon">
                    <item.icon />
                  </span>
                  {item.menu}
                </Link>
              </ListItem>
            )}

            {/* check if accordion */}
            {clicked === index ? (
              <SubmenuULContainer className="submenu">
                {item.submenu.map((subitem, subindex) => (
                  <ListItem key={`submenu${subindex}`} className={"nav-item " + (location?.pathname.includes(subitem?.group) ? ' active subitem' : '')}>
                    <Link
                      to={subitem?.url}
                      className={'nav-link'}
                    >
                      <span className="sidebar-menu-icon">
                        <subitem.icon />
                      </span>
                      {subitem.title}
                    </Link>
                  </ListItem>
                ))}
              </SubmenuULContainer>
            ) : null}
          </React.Fragment>
        ))}
      </ULContainer>
    </AccordionSection>
  );
};
